import React from 'react';
import MediaPage from '../media/MediaPage';

export default function StudioPage() {
  return <MediaPage />;
}
